
import React from 'react';
import { UseFormReturn, ControllerRenderProps } from 'react-hook-form';
import type { BlogPostFormData } from '@/services/blog/types';
import { FormField, FormItem, FormLabel, FormControl } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';

interface PublishingControlsProps {
  form: UseFormReturn<BlogPostFormData>;
}

export const PublishingControls: React.FC<PublishingControlsProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="author_name"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'author_name'> }) => (
          <FormItem>
            <FormLabel>Author Name</FormLabel>
            <FormControl>
              <Input placeholder="The Mat Monster Team" {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="published"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'published'> }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Publish Post</FormLabel>
              <div className="text-sm text-muted-foreground">
                Make this post visible to the public
              </div>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
};
